import { STATUS_META } from "@/lib/api";

export const StatusBadge = ({ value }) => {
  const meta = STATUS_META[value] || STATUS_META.ON_PROCESS;
  const isUrgent = value === "URGENT" || value === "BROKEN_ORDER";
  return (
    <span
      data-testid={`status-badge-${value}`}
      className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-[11px] font-semibold tracking-wide border ${meta.bg} ${meta.text} ${meta.border} ${isUrgent ? "animate-urgent" : ""}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: meta.hex }} />
      {meta.label}
    </span>
  );
};
